/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./app.component";
import * as i2 from "@angular/router";
import * as i3 from "@angular/common";
import * as i4 from "./providers/authentication/auth.service";
import * as i5 from "./providers/nom-web-services-json/sso";
import * as i6 from "./providers/authentication/sso/sso.service";
var styles_AppComponent = [];
var RenderType_AppComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AppComponent, data: {} });
export { RenderType_AppComponent as RenderType_AppComponent };
export function View_AppComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_AppComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-root", [], null, null, null, View_AppComponent_0, RenderType_AppComponent)), i0.ɵdid(1, 180224, null, 0, i1.AppComponent, [i2.ActivatedRoute, i3.Location, i2.Router, i4.AuthService, i5.SSO, i6.SSOService], null, null)], null, null); }
var AppComponentNgFactory = i0.ɵccf("app-root", i1.AppComponent, View_AppComponent_Host_0, {}, {}, []);
export { AppComponentNgFactory as AppComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/app.component.ngfactory.js.pre-build-optimizer.js